export const LOCAL_TEST = false
export const NEW_RECORD_SYSTEM = true

export const FUNCTION = {
    /** 账户管理 */
    ACCOUNT_MGMT: true,
    /** 升级管理 */
    UPGRADE_MGMT: true,
    /** 系统管理 */
    SYS_MGMT: true,
    /** 统计管理 */
    STATS_MGMT: true,
    /** 日志管理 */
    LOG_MGMT: true,
    /** 动态管理 */
    DYNAMIC_MGMT: true,
    /** 日历视图 */
    CALENDAR_VIEW: false,
    /** 推送管理 */
    PUSH_MGMT: true,
    /** SDK管理 */
    SDK_MGMT: true,
    /** EDF任务 */
    EDF_TASK: true,
}

/** 表格页脚样式 */
export enum TfStyle {
    /** 全部展示 */
    LIST_ALL = 1,
    /** 百度贴吧样式 */
    POSTER_BAR = 2,
}

/** 当前表格页脚样式 */
export const TABLE_FOOTER_STYLE = TfStyle.POSTER_BAR

/** 表格页脚显示的最大页数(PC) */
export const TF_PAGE_SHOW_MAX_PC = 10
export const TF_PAGE_SHOW_CURRENT_PC = Math.floor(TF_PAGE_SHOW_MAX_PC / 2)

/** 表格页脚显示的最大页数(Mobile) */
export const TF_PAGE_SHOW_MAX_MOBILE = 6
export const TF_PAGE_SHOW_CURRENT_MOBILE = Math.floor(TF_PAGE_SHOW_MAX_MOBILE / 2)

/** 用户角色 */
export enum ROLE {
    /** 超级管理员 */
    SUPER = 1,
    /** 代理商 */
    AGENT = 2,
    /** 用户 */
    USER = 3,
}

/** SDK用户角色 */
export enum UserRole {
    ALL,
    ADMIN,
    NORMAL,
    GUEST
}

/** 报告类型 */
export const FIRMWARE_TYPE = {
    "CA": 1,
    "CB": 2,
}

/** 固件类型 */
export enum REPORT_TYPE {
    /** 睡眠 */
    SLEEP = 1
}

/** 固件版本 */
export const FIRMWARE_VERSION = {
    "Beta": 1,
    "Final": 2,
}

/** APP版本 */
export const APP_VERSION = {
    "dev": 1,
    "alpha": 2,
    "beta": 3,
    "pro": 4,
}

/** 面板显示状态(关闭和打开) */
export const DisplayOptions = {
    none: "none",
    block: "block",
}

export enum MobileType {
    Android = 'android',
    IOS = 'ios',
}

/** 默认的可选每页记录数 */
export const DEFAULT_RPP = [2, 10, 25, 50, 100]

/** 默认的心电图画布缩放比例 */
export const DEFAULT_ZOOM = [1, 2, 3, 4]

/** 数据为空时的填充数字 */
export const EMPTY_Y = 999999

/** 数据为空时的填充数字(波峰索引) */
export const EMPTY_PEEK = -1

/** 日志来源. */
export const LOG_SOURCE = {
    /** 日志来源是 android. */
    ANDROID: 1,
    /** 日志来源是 electron. */
    ELECTRON: 2,
    /** 日志来源是 iOS. */
    IOS: 3,
}

/** 记录来源. */
export const RECORD_SOURCE = {
    /** 记录来源是 android. */
    ANDROID: 1,
    /** 记录来源是 electron. */
    ELECTRON: 2,
    /** 记录来源是 iOS. */
    IOS: 3,
}

export const getSourceName4Download = (source: number) => {
    switch (source) {
        case LOG_SOURCE.ANDROID:
            return '';
        case LOG_SOURCE.ELECTRON:
            return '_electron';
        case LOG_SOURCE.IOS:
            return `_${LOG_SOURCE.IOS}`;
        default:
            return '_unknown';
    }
}

export const getSourceName = (source: number) => {
    switch (source) {
        case LOG_SOURCE.ANDROID:
            return 'android'
        case LOG_SOURCE.ELECTRON:
            return 'electron'
        case LOG_SOURCE.IOS:
            return 'ios'
        default:
            return 'unknown'
    }
}

/** 记录存放位置. */
export const RECORD_LOCATION = {
    /** /data/files */
    DATA_FILES: 1,
    /** ./uploads/records */
    UPLOADS_RECORDS: 2,
    /** /mnt/volume_sfo3_01/files/files/records */
    FILES_RECORDS: 3,
}

/** 页面通用常量 */
export const COMMON_PAGE = {
    MIN_AGE: 18,
    EMAIL: 'support@smwmed.com',
    ADDRESS: [
        // `9920 Pacific Heights Blvd. One Pacific Heights,`,
        // `Suite 410,`,
        // `San Diego CA 92121,`,
        // `United States of America`
        `9920 Pacific Heights Blvd. One Pacific Heights, Suite 410, San Diego CA 92121, United States of America`
    ],
    PHONE: 'XXX-XXXXXXXX',
    LAST_UPDATE: '2024.12.25',
    CORPARATE_NAME: 'Smwmed inc.',
    STATE_NAME: 'California. USA',
}

// 应用状态枚举
export enum AppStatus {
    INACTIVE = 0,      // 停用
    ACTIVE = 1,        // 正常
    PENDING = 2,       // 审核中
    EXPIRED = 3,       // 已过期
}

/** 管理端使用的公钥. */
export const publicKeyAdmin = `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAuIK/wK87q/2gru5lx+03
tFnJJeVH/xReBgXl+YHo7vCV4k5XhaU+3tC7rPF4x5BOBTmqSl1m3MDb8+ATBQez
xXGhnt913+4uFGZcXYDInmG6f2jy4/cAemhJ4KUQYAV43URd63a0sifS5aAjVexl
0X5l9NsesLSahTHWCgLErks3GVkBRywmeWxNUhXs8rAiy8pOWNkcJ95p9UssVdG+
TbmPSjDCg9R/MxDo+nPCOMUdCT1xDFXsQJukoVzSFKMrYMCDAxCUD5hh8MAOX76c
xCcdFYD0mKWn4uD8dvlKpKwqZlpmkwMq2c3eN1fPO7vXr2Yk561pP29mFpPNGuca
IQIDAQAB`
// export const publicKeyAdmin = `-----BEGIN PUBLIC KEY-----
// MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAuIK/wK87q/2gru5lx+03
// tFnJJeVH/xReBgXl+YHo7vCV4k5XhaU+3tC7rPF4x5BOBTmqSl1m3MDb8+ATBQez
// xXGhnt913+4uFGZcXYDInmG6f2jy4/cAemhJ4KUQYAV43URd63a0sifS5aAjVexl
// 0X5l9NsesLSahTHWCgLErks3GVkBRywmeWxNUhXs8rAiy8pOWNkcJ95p9UssVdG+
// TbmPSjDCg9R/MxDo+nPCOMUdCT1xDFXsQJukoVzSFKMrYMCDAxCUD5hh8MAOX76c
// xCcdFYD0mKWn4uD8dvlKpKwqZlpmkwMq2c3eN1fPO7vXr2Yk561pP29mFpPNGuca
// IQIDAQAB
// -----END PUBLIC KEY-----
// `

/** SDK加密用的公钥 */
// export const publicKeySdkEncode = `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA3pkIDCRTH+g9fEU1PVMI
// UfquQYb4+3OpEyESXW4XU9r0V0tl7+S3i9/r6toDWYQMKlyGzBk54OOr281oFdoD
// h/YHIfF0/wt7Pb2DLR19rIvrihRy41ivlUIxg0/+qo1ATm1DaPAEnKTqt5noMxi3
// X3G9EVDJDxxD05mttqjhmx/8BPS5qaTyHN7WN1YNWt1C3K8UrFle1ohu5fqdVqtG
// N/EBUvsAI5E3gKeerL9PTQiz3L0DUZpplfkh6bny8vnk0ywAXnVL4am4ajidCipl
// +CBD2OQOmaminyPULYLSZWVbXhzSTUAiYIMrLvZOBDCDqrHbkRDFErXmT7tNESbd
// nQIDAQAB`;
export const publicKeySdkEncode = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA3pkIDCRTH+g9fEU1PVMI
UfquQYb4+3OpEyESXW4XU9r0V0tl7+S3i9/r6toDWYQMKlyGzBk54OOr281oFdoD
h/YHIfF0/wt7Pb2DLR19rIvrihRy41ivlUIxg0/+qo1ATm1DaPAEnKTqt5noMxi3
X3G9EVDJDxxD05mttqjhmx/8BPS5qaTyHN7WN1YNWt1C3K8UrFle1ohu5fqdVqtG
N/EBUvsAI5E3gKeerL9PTQiz3L0DUZpplfkh6bny8vnk0ywAXnVL4am4ajidCipl
+CBD2OQOmaminyPULYLSZWVbXhzSTUAiYIMrLvZOBDCDqrHbkRDFErXmT7tNESbd
nQIDAQAB
-----END PUBLIC KEY-----`;

/** SDK解密用的私钥 */
export const privateKeySdkDecode = `-----BEGIN PRIVATE KEY-----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-----END PRIVATE KEY-----`;

export const rsaKey8192 = {
    privateKey: `-----BEGIN PRIVATE KEY-----
MIISQgIBADANBgkqhkiG9w0BAQEFAASCEiwwghIoAgEAAoIEAQDP3xRiKl4QjdzY
bxmDhv4Rftcsa+fVKumDgPAVeIu3XhV7bmhrrnYwyIAKjKErwhELV5DXcCkQKF60
SGi9iLk0nBvrThUO9HvY2yjiU+8MvShz6bGkDYwnGRiHYFgyG8HLb8cnl9QW/NcS
4HV0LEYcW0DA1EkFJK67WUji9HhXNDTa6K456lq+UQ8ksmCctJEdqNAgMAHFpKSx
oj9froRDluM2pjRxViv/1iVwU0SEdvV5Wp+nOUqb2E/xhM/Q/a/feBrkU+Mu3DaS
tsCkOIEqsIpLpgGpMEXRr9d/VENIkutm8Mzf3EVuWSTtIXs8GKBI7AU77ZiQUgAQ
OKYsidDn0uPVeVXGTf78hbyQp0zhcBxAX+hhNdFnzbkqFEohuz3cPWZBEyIPwE3t
o+4IOQaQrUbPTi6bLL7ahMYD8Ptal9XIvJ0taVhQX44OPmXfXJg40aXQxOikYK+m
pfkWYg9vNzP6eGmK2IZ79hBQ+GblJOxijM5i2JqinY05tEWQA66+Ay3v9tPwj1+d
6he8f14aE/sk5KSAyoi8drrqYdpYBtjlrUsGRaRn8vwgI/iNvN8FOsoV2oPaBmeE
hDDrFq3IabnVgj91WYPUyNAwzxmhlnf82LsNtTEtq951Y5lFkbriXFxjKauhRwIP
vMVol2PYX/ECLIMMiuu7+aVyxzkWMx/w466cNrJC8xmMtUexcpzJaYnU36+jAd/d
i5ObBSbBO8ruRaGqcIg2CGGJMxsr7vor09LfZyPEo5pQFXxdX9F1Flw9uqycYAdJ
lHGCjwHWHXlvjh4hSQzuKSXA0J2otFywCM47mGWgx2XXbeD8OEgvlXMTqGlnkhkL
CSkj2OAltwxqq2g+09IiBTvfPDqW1oHbyhtGhzAvLnIO/Q5+l+gxjzJ9iqRLAtqh
4rqZlUixaJfogTKJwMrFJiwIOH+gODlYalihXD/QA6hZ6tFYWThXbJz++kICO2wa
pzG+X3vchIul7/nQ7D1jPVF69uKAmUl1GorSHCoRZvrf30BlkWDMfADORqP5xYze
ikfFlAyuUqWi3v2rnvvzwdsuayimMbDARRmSADmvVNVodvmrPnGsqW8B3is80VCK
44uO8d3NsaIOlElG/KZj+f5dfuQ6INGHvSKz3BGbhPQYao0FHh4zwNs7smUnJQyu
yKJwaE1GG0csNsK4BOLqq+AVjWygsn3kDt0N3nYdIc7odzEctAAIXzzizLu/Zfxo
eOZnMpxseBpL/kuqfw2h+QiZCrnjA4z0Q58u6IpjxXhEYN9llq5kJr7iVsnUvw7+
N1IENY/PvAYV3PiVhKhcfbCJojqOJqwHFFXwjAcmhLDQQeUQCnzTR2gZ6LrTyV7C
BHB+uPIFAgMBAAECggQAAOQq+TTHTHjfPopTaK32fuq1T3py9wYFFExEO0NWDgY4
P1w81GFeHl1ttx3dPwvI+Ox6MYJImsohhdJdqJpieOhGcl7WVkcUFNzzsuy7NKnG
96BD47kvJafE5Ce0mRpnXVDwYKoU/bg9z9XoiwP5lPuLLoh6e6wpl6INXvO/ZFhT
9bBTtunbU7+TOgwNv/5CNQdZRRoPl+JZ1m0kqmtcI9IMzVovFWFSNPmdFXs16v97
k/aggp4LRNnLlfSE05eS3nlsXBhD/BpznXNtJgcb/qvdG+/tR+VuFzUSznf1BeWj
XsCfkEIohg2Zy+590cclQMrKRvSA1/WSDH/BrqU0oRnVYj/v7za8ZibIpTIicUEC
zf/bRjdt220VYynNG5Hq9PvKaXMEjV68ts0iIyTjc1Fa4V6rcnzhoJw7IR8yZLQL
9Z1hayVtfIK8YDFCTI/gEzZK6Lc/bB0CA8voYoEvIcHx1hwYD8FX6kYm0cIO5uKe
pNmHtQLKvvG//kRYnAJ4CFaJJuM/C2QB+/JaAbPmGmSFiiX00pyLs4sqyAB9aC03
VtzEWpWH2+49yIF++lSZ/DLBVRCnyhKG9RmAADILsrVJV7IERaOJniryQZNRv9Ce
WRYwzyE8wb5f6M7xhEvYqknNF5vBIaLlTl331rf3dKEMrn60XSRnWFn8rJ5QD1lM
ykxm7+UcnO1SbYayNldnzVDB5pdb2MzrFWYgcDmNLWb0Z2PaTJw2e3E/pjcXj/uJ
PiCZVfPfjj0PVIeqDEoXPb5DglxW3UeUkpV86aYVA3Bkw6pn2IzBp8fJu4p5lqag
IJFwj//EmsISuUyCEMotRLsbkqkPte8An9Q7mVlvwlIBVTkZA5XOZZAi7AxHyIub
aF5Nkxt/8LMKa3h1TUj3eO4JbOFKAuR/+8m9/H57P1us29qjs+TAZK7Mh0cAUNyd
YgOE22xo5yWI0CQ1lRXc2metXSv2jEPAPkOR3cvEcGIzmmsJVJAx7u+7qZjxUKE4
9M4PdD0D/t7w/udmjP8vBUBfYmqnbiNT29yl0cng2xEero+XEZmc4Arx5RjKgLk5
3As6oZMGIFRDLnfxF9xd7/JSIe4Bkf00QF2U4qmnruHMJC/ceTh7TqyhGP8U/Pg4
l8orrPg/uILi77HbfNPwCYtzucB2hOt9Ek7ALC9dlcB18f2dFypYrH/xCqrZDIay
nUc+Bq3qccz/UflbVt6IZ47egjfnl1in+OcPdhVdwpdFx87Jfkvk7ZLzXXYefaq9
ZrlikXiLbX+JArvcLqFJ2xC2jvQeqQldRiyswH/7Mt3fb2oY6oD8yYgcgjdnG23B
rw4RHGYVB+W12JMjBIprU248Xiglg3yQoe7b4mr0rQKCAgEA6Yt6GYRrsihPPIXU
V6fH7F1vohVJ9/EMk2hnV00dZNtXPmsSM1CiBTXcU/Rv1fWWJ1FdKNyse5K+i92A
ej098KPXId8r+859VngW5k6YYcf6gqnbB/3X6w2EvBn0U2ZcCacU6GO8Ni2umMPr
i1Fu+EdN0j0ms4ZKQZRSjrp5FYtrIGv5QN5FIJL38B3+DE5gvJaOk7h4o3ihYxuq
DvkvQE5D6AAZ7hOotCRGLXexXzrVU+141Q8/7zIFc0ML+ddyhspA6Sg2q9sH+n8v
zuZdnvFdq6QVRp1x78AgxVGYrJxIJzxO4Zscuh5uqIZs+qhMTDNhCWjiJr4R3lMh
x00xIKG//u+C3AevfDyWxqfIP0pI4quDJmt4HMu/uyQgFn0lB0ZF75eUuVOFXkdE
w6Igf24XYiJmAYUio10ZWIyxgBsgQdKdW5OnsPvtr/EPHdqq2XUGCz03sqAaA15d
5QdhknQe3/KV+jgrJm1c29WyR7QGg8AIYZczkougKbUhVW6G3g1/RVaH0yfA6sJM
dbd5QEm1ew999fBrp5QON5hJB8uLG7l8MPYEKr1xW+rrBATe5U71Vxs7Wgi/LIgT
PnOzJYldH08c+O4f1/A1ePy0U8QxDTwwB9vnBBetX+4WI8UezEjUeiiX4zekZPg9
QB+SLgGjwPVf6Vnh2MzNcdRXxt8CggIBAOPbq9+G5PUi5guguumgVdUeB1+v3GEA
hVjsS47jUuSPOXOZvjDj0SkfZHQa647wG5RMfJ6TZI6VjCsQMhcfGEjThSXB/3Qc
vXkYfunTZhQxS8Zu/yWqow1YfpfQlDNeZF6ztdQiQ3466BPMPMOhdIh5s8OrHD9z
Tp8iHhIjMTrhkmMh1XfWPooMSeSj58lRNvPBZX0o3U9+FZrInej6r+/0I8sFcbjI
pso2zQqjveJSNFITLTXRjHCWmMkZatfm5kWR5TnGV2MqVeh0rK9F2Qk2M5g2J74l
p1CcSi07AObM3L7zhf4nqp563LDaen93PeD9Yc9812iNsiiIvCXUSl6+396ILoLl
jWm9u0+F7dWj1SaPQNjmP/KaDR1E4qq+tKv2uji733mo5N1pDitIeFKHN8k6cj3D
uzY5yQ9BiAW/y6khitM0vT8O0x562Xf6JUklJrl/0jRhz6g5yCmk+p5w1pM+AcA4
wz7PtDiKu7KPTm8yRudATkWUPGo0yxitY/r2k97ZGXwK1zcUPZQD3ZMFeWlgJCCu
3cyTtCUcgd2M2m93kjqD15tn1EG2ywck/lRRr37eu9uXL71ela1AuEYG6PD16RX/
MoTpnMpLKgzPWYBVFzrhygRdgQSxfiD1y6SyohlOnEo3FV63PJaoGa6dMt5bo4nW
wg/7JPC/epebAoICAQCguFC9sMigoWbuIrdf32IRQrfpVjdCPwvFgerkRHh/CQeA
OBUdZVcquMc4q5YvK0Q7KJ4w2bSFkhY5kKSy+uReb5JEiB3vu0m8MQapVds+J245
b4UBeeqWowX+oOnoXx/lsKsNxl0m98cY8HNvvAnfKMrgbR7uGvONL/KksKVVc020
0TmGL7Bo21tvTmSfuWyPPBlAhYnYDdMarlYY2dlvqqzGwxMVKUhHOFNnROC2xXk7
ucgW79iy1ryzdqeON3tkUVncWsVM/X3/IHoZK6WwFTC+RzwxDXb0ZEbpI98qop5x
CerLDYD2gKzsox3qXdmr8wvLevdvbAxF8PXk/zVY3JeRbOikXVGh8NxeN+bxz0Bb
ZWbrELhnMLxwoErIzzSlTfIhETLTWywEFo23CCLPL0c+TKfgUevletNPgftBSumn
Arcx52pWvPj0xLL/e5Vp80PGhkmHTvC38sAxNiQqsmjw+zPFL9RaLJbj3qtC9xwo
nQXnizN9nUMKkNEwxtBfjfBRGlx8rvXvWOlfdXUnDdKrrpyjnOGpQJWMIuvXRnck
DEDwPM3fT+HsPL2hVWzDZ9QlLuNocW6GydpcdykJIwAH5NzuXolhhLh324iJwRF0
pz/ymJ3hzh2NT/7CfQxVz6URsE/emVMz/TXBpDhoGs7DotlvcGChX0ffFx+VBwKC
AgBOZQHZQfv8KymizoYAY12kmVRII6Va6mb2lTXZz3RxlqVZlIfPIlKQJ3DUUX7C
CvIyL66gkG2EcQdsuYHCWrxsMfoZZ4mQVWMLCtZ/dHAmel9rwjyepPq8WLoVWXnj
wpId0w64EaHPCE1Yomg1lpMVcWnb5D8vxWhDb+WQr/L8IyfOW5GqTVfu/xNdStcw
eHTDoMJeMXUTKHoeau+JfNaTZBf8fb8GqGJaKEibZIKsH0RJCLgBUDtVcTrX1Zrg
9Vw8i1mmawsd3y73b00KcKmfdbqCn/9EeIf8QAl1TludDNbWC8sKCnO1WugbINAM
kuYDRqokTPt/yWCGeaTiDwwXVOyJD6mQ95GT0+diEN4nJtrrDVZuSamuujnQ3CZw
QHTAxX6Ejn7wyJ8VXlO1qJVdL5CN90He5jy/B1qZmR5HfBmB8zxkNjz2OQ+B6Rpx
IOs7I0ETiVq1EwHzCw5G5bAkWwY4WpkXnW/vaF7FJVY2tP9zWoTygzlqzvmKQOev
cdh4O+XcQi12c/RfyuL0ze+p6bRAAQftBrzg6eCM9CXqJ8/vkeAJqdrAaRSqF037
A0tNj10l9VQE1Rtjt+sfVKkRzsbOQI0VOFwVRprfLsUk6yIL+Tqo045Bujntd3PB
u095Nsx2kIlNL252y+xYmTVc0lDyF+1IO09BWFL5UafICQKCAgBoBj4frsVbldk4
ew/zdSExg2tBCnuQo3RdM46g00uHdVKP49pOCz2XmSnnw5kxeHeIqIxUeU30fsVp
O7lIpnOvbAqHFXdhfiz1V+KrTTqTKA1CZXNxdaJMHWcAalyUId4u+YhOWhe7sFCk
w9fgmtzj7sVM+kQSEUNomnN/zhAAXzCYbgSYmgA19L2JanyUCS+D7kNfrMLbDgqe
nTS2hNb1mv6MjSnupZShCoqS311S9ZBTOmrkdT9SnrOjplzG1G90F+qvkEddplym
9UPqkg5dNx7uI2kb2+gKTDHTwqslRkkoiqDQcLAvWruimogC0Q1K7kIBdHWUPYpu
IIKOmDghH62zrb+L6dZZDl/qY5Yho7Kt3zpN5ul2nx+gFx4pNBc9pfkEneARRXjB
vdGoASM6bAdKh3agU4/OHI8yWBWmuUYFc1dE3XnA7mtSK6+kgNVFt4upIZw/12E1
szkUTwibmHVEsg3pYnJKQkY8/jRy9RAFQAIQpTOoz4jdaqp/GtnAcaqYIrHtwo9/
R9qckkRmmeqySmm+bmvGFzPC6ddMDLRawOJbayPD+5H7R6qVOL8QjC/xIAStFxTA
HImLpP9usfF03KDg41Y+tXdsimJOCRQ7v4M5u2BBOW0DdHLWa2GWOlO1sGd1E1Xf
dc1nYHH0dyTxFUO56qSYP+05gIATig==
-----END PRIVATE KEY-----`,
    publicKey: `-----BEGIN PUBLIC KEY-----
MIIEIjANBgkqhkiG9w0BAQEFAAOCBA8AMIIECgKCBAEAz98UYipeEI3c2G8Zg4b+
EX7XLGvn1Srpg4DwFXiLt14Ve25oa652MMiACoyhK8IRC1eQ13ApEChetEhovYi5
NJwb604VDvR72Nso4lPvDL0oc+mxpA2MJxkYh2BYMhvBy2/HJ5fUFvzXEuB1dCxG
HFtAwNRJBSSuu1lI4vR4VzQ02uiuOepavlEPJLJgnLSRHajQIDABxaSksaI/X66E
Q5bjNqY0cVYr/9YlcFNEhHb1eVqfpzlKm9hP8YTP0P2v33ga5FPjLtw2krbApDiB
KrCKS6YBqTBF0a/Xf1RDSJLrZvDM39xFblkk7SF7PBigSOwFO+2YkFIAEDimLInQ
59Lj1XlVxk3+/IW8kKdM4XAcQF/oYTXRZ825KhRKIbs93D1mQRMiD8BN7aPuCDkG
kK1Gz04umyy+2oTGA/D7WpfVyLydLWlYUF+ODj5l31yYONGl0MTopGCvpqX5FmIP
bzcz+nhpitiGe/YQUPhm5STsYozOYtiaop2NObRFkAOuvgMt7/bT8I9fneoXvH9e
GhP7JOSkgMqIvHa66mHaWAbY5a1LBkWkZ/L8ICP4jbzfBTrKFdqD2gZnhIQw6xat
yGm51YI/dVmD1MjQMM8ZoZZ3/Ni7DbUxLavedWOZRZG64lxcYymroUcCD7zFaJdj
2F/xAiyDDIrru/mlcsc5FjMf8OOunDayQvMZjLVHsXKcyWmJ1N+vowHf3YuTmwUm
wTvK7kWhqnCINghhiTMbK+76K9PS32cjxKOaUBV8XV/RdRZcPbqsnGAHSZRxgo8B
1h15b44eIUkM7iklwNCdqLRcsAjOO5hloMdl123g/DhIL5VzE6hpZ5IZCwkpI9jg
JbcMaqtoPtPSIgU73zw6ltaB28obRocwLy5yDv0OfpfoMY8yfYqkSwLaoeK6mZVI
sWiX6IEyicDKxSYsCDh/oDg5WGpYoVw/0AOoWerRWFk4V2yc/vpCAjtsGqcxvl97
3ISLpe/50Ow9Yz1RevbigJlJdRqK0hwqEWb6399AZZFgzHwAzkaj+cWM3opHxZQM
rlKlot79q57788HbLmsopjGwwEUZkgA5r1TVaHb5qz5xrKlvAd4rPNFQiuOLjvHd
zbGiDpRJRvymY/n+XX7kOiDRh70is9wRm4T0GGqNBR4eM8DbO7JlJyUMrsiicGhN
RhtHLDbCuATi6qvgFY1soLJ95A7dDd52HSHO6HcxHLQACF884sy7v2X8aHjmZzKc
bHgaS/5Lqn8NofkImQq54wOM9EOfLuiKY8V4RGDfZZauZCa+4lbJ1L8O/jdSBDWP
z7wGFdz4lYSoXH2wiaI6jiasBxRV8IwHJoSw0EHlEAp800doGei608lewgRwfrjy
BQIDAQAB
-----END PUBLIC KEY-----`
}

/** 亲测可用 */
export const rsaKey4096 = {
    privateKey: `-----BEGIN PRIVATE KEY-----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-----END PRIVATE KEY-----`,
    publicKey: `-----BEGIN PUBLIC KEY-----
MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAuLRNMYCLciNQMZ6XZnyp
4a1vZpS9lnol5Jc7dyDfIKybzMap8XX9m2qNgCQdHollnTkIBp+LVoH+ciQCyYe/
/dozLQ4AJMnDLWQ74Ox8IOBOSYhv0XjpLFZFWHI+gREyAjMxOC4WyXL05zt+bkrI
Md/bET6SB7ySHhrs+ZIY5XvjuUv9oFk9WCjtrT0Snl+B8MwJyEGpi5Edln2w/xRH
wLLOaOch1Bt5FnAkPyjpKUReOwcZ1s7qUZIe1g7bWUXJUESubTe+ayXrh/9hBgSI
wUXBz/PSqh93Io4FpFpplLMJkDlDQNnUXI6XqJ2wBwO3xn4vp/Isa5jsQ0xhhkh/
88WKp2xhPJzuTO5pl6rBCdtRLe3nojuHhSKeCzrk029/39t5KJt3YsalMKsliyRh
Zq3lP3XLJFSNKc/flrEBltu4kb7uyD6oyanEYFu8OMUAdknc8y4tD3kI0B2ojYMU
UpTd4x6Nys0czjHRrCgJIQ0DTReXTysiC3bPKhlWWRQL2/EIhq4q5bkUdLUF1Yur
qZFo1dFZyUSN7CmexPNHJj/J1F4Dmc76ShUpQAZ0Lyg/ss8MnMyd4/9kKFpO/sKJ
XBOdA6yFE9jGnoFxgONtI3x1HiBui/ql8yEOvL9dFp0vbRJOiIA7NoqS6j7iCFEL
HkLh4qnA6ESi56bir4e+K1ECAwEAAQ==
-----END PUBLIC KEY-----`
}

/** 亲测可用 */
export const rsaKey2048 = {
    privateKey: `-----BEGIN PRIVATE KEY-----
MIIEvwIBADANBgkqhkiG9w0BAQEFAASCBKkwggSlAgEAAoIBAQDJYVny61FFmCL/
Wb8xXDr86wGYqdRXfO1dYNVxLuatLY2FIif/6mVjxjhl5hE79omwa+yqkN+sIBTe
9uWfSj097nQf/qq3awDvqSTTOPSdFIL2cscsEM4BJp5Yfmyjms/vW3Bj0QRfw4U4
hDumQNsnhjSaHiAWdlCCOVjhQlyfj8Dk2Ivy2c4aECurZYgj4chvVS3+WBL8hjVM
RNuMtREQzviJV2Yd+LMnq5NGD8M+mibTeBA4/QFS85p5VIVGKZnPDC0EmPhRhaac
WFnFh/vCGVwLm129oPBhaE4yMGIKYUnTkD5P77ytbYQm+PGdXK1K4IOUss6sBgu7
ty+oD02fAgMBAAECggEAMQnS1JO3E8Jra1EYfNWfy60Sk3FvsupKBv4om8o3BB7e
onfh07DphbVkUHQI6FgtyVdOp25l+U1Kp8zpt7NlXGpvvsbOHaIh9Tp0LDdnYcT3
6zmiBLoG4ELeNmB65hAx6HCU2smwTf2XuF6DBAYxF9vXfVwupimji0KZwSje0z/I
usHUkZeuwXt/3aYGzudUemFcCmUxgMR9KxUN+ZmDq4XgJpYf6xKWEbjN7JtulBhV
8rRKArRPaWzyrs0Q9161PScFnWdQr6YFtSBPzXzQBxPUtKZQvLnKB6owwEZnA76c
VScWJPyAVU87T/OPwuuhjJJUjfQMaQ7lVpKe0+vBwQKBgQDmESRzxgxhzVRKk/rX
IJpYZpn6Pekmh32k1d1n2nyD96WoA9GoXvtAYngPHP5gruG99nbGwsWILtdWA8QM
S/mgE+sKs88hCHfmmXoB89rhfdgYkp2m2fk+2ub7vn4ZLoo2lbifDMY+237xw0df
STg68K8es1nhtSFLvK2nC4lt4QKBgQDgFGudkOkzXgGOZa7b3BaibIJxJRqAPpcO
+DSFQC1FGu7l56xsm2MAlbSe6Q7lSbflRwhuCR2xe03ZRs79DYGRHPW/IGja4RBb
6Y4rtY/ymUZqjp04kJ4rQQssM9WWIFuSzeJ6KHmxH16LeQfD2xseiMc7ZLbfYDsH
Wwic5Q0rfwKBgQDhZsof41keONzsdC69teOB2IPi9+UFKpmedSmGJjj30hkqkxNF
skjWu6KErBNNBgmE44NbGFgPJFU0oFvi8EyQ2PLeeWvlITbXZmZyo0c+xNyCtqJe
ZhAb1LuYyPkiEsa209kdepZ/3uxwULIMWOAOXuAzY+Qbjiog2aoIjvUGAQKBgQDd
bFBLCv7le2ceRuxa5UiYh5D+LSPaxf6PFEURxzD0sICRPjTrvUA/O6+Xt8S4XfgR
3/c8hFWLI8Txhz7SX55AvtU3X9c9Mljv+gI6vtbXaw5iDTrewkkJhOR9cVsFVkQm
9Ltu6sAVfmH2gEpkBwbtTUtSLVtnr7ektRf1sYEqEQKBgQCbit2fCDoyiA4+FVJP
W7PEKnq3rn31P9LnBtZ53gRfvstlZSkD0FzrlhYT4JFM4Zt1Wh5gimhJ7p3tp9ft
rtct3T2ATanuwrBPdoltVFhOQwDulFCbu5eNxxCf7/Xf9npXEMewldjmOF2i7zU8
4i+9t2SCqy9DYXigp1nrbZsBxQ==
-----END PRIVATE KEY-----`,
    publicKey: `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAyWFZ8utRRZgi/1m/MVw6
/OsBmKnUV3ztXWDVcS7mrS2NhSIn/+plY8Y4ZeYRO/aJsGvsqpDfrCAU3vbln0o9
Pe50H/6qt2sA76kk0zj0nRSC9nLHLBDOASaeWH5so5rP71twY9EEX8OFOIQ7pkDb
J4Y0mh4gFnZQgjlY4UJcn4/A5NiL8tnOGhArq2WII+HIb1Ut/lgS/IY1TETbjLUR
EM74iVdmHfizJ6uTRg/DPpom03gQOP0BUvOaeVSFRimZzwwtBJj4UYWmnFhZxYf7
whlcC5tdvaDwYWhOMjBiCmFJ05A+T++8rW2EJvjxnVytSuCDlLLOrAYLu7cvqA9N
nwIDAQAB
-----END PUBLIC KEY-----`
}